export const AtlasAppId = '1e4d4152-aa44-4e38-8960-82820376e45d';

export enum EmployeePermissionType {
  CanViewAlberIQ = '5b7c61d1-e91c-436e-80f4-0ed0c6039ca9',
  CanViewProjectSiteConditions = 'b029260b-18ce-4e5b-94f5-ee403c914be5',
  SuperAdmin = '7ac30441-3e14-4e19-8164-768c967faa2d',
  CanViewPPRList = "6ab6472c-75f4-473c-9a9f-ac425cbf2cb2",
  CanOpenIndividualPPRs = "03d3fa00-7334-4f1c-ae5c-21672fa985bf",
}
